export function AddAttachment(organizationID: number, eventSeriesID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/event-series/${eventSeriesID}/attachments/${attachmentID}`;
}

export function AddUsers(organizationID: number, eventSeriesID: number): string {
	return `/v1/organizations/${organizationID}/event-series/${eventSeriesID}/users`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/event-series`;
}

export function Delete(organizationID: number, eventSeriesID: number): string {
	return `/v1/organizations/${organizationID}/event-series/${eventSeriesID}`;
}

export function RemoveAttachment(organizationID: number, eventSeriesID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/event-series/${eventSeriesID}/attachments/${attachmentID}`;
}

export function RemoveUsers(organizationID: number, eventSeriesID: number): string {
	return `/v1/organizations/${organizationID}/event-series/${eventSeriesID}/users`;
}

export function Show(organizationID: number, eventSeriesID: number): string {
	return `/v1/organizations/${organizationID}/event-series/${eventSeriesID}`;
}

export function Update(organizationID: number, eventSeriesID: number): string {
	return `/v1/organizations/${organizationID}/event-series/${eventSeriesID}`;
}

export function UpdateUsers(organizationID: number, eventSeriesID: number): string {
	return `/v1/organizations/${organizationID}/event-series/${eventSeriesID}/users`;
}

